import React from "react";
import StaffProfileCard from "../../../Staff/partials/StaffProfileCard";
import { cleanDate } from "../../../../util/app";
import TimeAgo from "react-timeago";

const InterestChecklistList = ({ items, onView }) => {
    const tHeads = [
        { title: "SN", width: "10%", className: "text-center" },
        { title: "Staff", width: "35%", className: "text-left" },
        { title: "Days ago", width: "15%", className: "text-left" },
        {
            title: "Date & Time",
            width: "20%",
            className: "text-left",
        },
        {
            title: "View",
            width: "20%",
            className: "text-center",
        },
    ];
    if (items.length)
        return (
            <>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            {tHeads.map((item) => (
                                <th style={{ width: item.width }} key={item.title} className={item.className}>
                                    {item.title}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((item, idx) => (
                            <tr>
                                <td className="text-center">
                                    <strong>{idx + 1}</strong>
                                </td>
                                <td>
                                    <StaffProfileCard item={item.author} />
                                </td>
                                <td>
                                    <h5>
                                        <TimeAgo date={new Date(item.created_at)} />
                                    </h5>
                                </td>
                                <td>{cleanDate(item.created_at)}</td>
                                <td className="text-center">
                                    <button onClick={() => onView(item)} title="View" className="mdl-button mdl-button--icon mdl-button--colored btn-default">
                                        <i className="material-icons text-primary">arrow_right_alt</i>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </>
        );
    return (
        <div className="text-center mt-5">
            <h4 className="text-pink">No Record Found!</h4>
            <p>No Interest Checklist Assessment has been created for this patient.</p>
        </div>
    );
};

export default InterestChecklistList;
